/* eslint-disable import/prefer-default-export */
import ReactPlayer from 'react-player'
import styled from 'styled-components'

import { overlay, vFlex } from '../../../../../../styles/style-helpers'
import { Text } from '../../../../../../styles/typography'

export const VideoViewerEl = styled.div`
  ${overlay};
  ${vFlex};
  width: 100%;
  height: 100%;
  pointer-events: none;
  backdrop-filter: blur(10px) brightness(0.75);
`

export const VideoEl = styled(ReactPlayer)`
  width: 100%;
  height: fit-content;
  max-height: 100%;
  pointer-events: auto;
  background: black;
`

export const UnsupportedFileTypeEl = styled(Text)`
  text-align: center;
  color: white;
`
